import { useState, useEffect } from 'react';

const useListItems = ({ breakpoint, basicArticles, additionalArticles, featuredFromOthers }) => {
    const [listItems, setListItems] = useState([]);

    const getTypedItems = (items, type = 'normal') => items.map((content) => ({ type, content }));

    const getItems = () => {
        let items = [];
        const pinned = basicArticles.length && { type: 'pinned', content: basicArticles[0] };
        const articles = basicArticles.concat(additionalArticles);

        // TODO return is table, phone, etc from useResize()
        switch (breakpoint) {
            case 'lg':
                items = [
                    pinned,
                    ...getTypedItems(articles.slice(1, 4)),
                    featuredFromOthers.length && { type: 'featuredFromOthersCards', contents: featuredFromOthers },
                    ...getTypedItems(articles.slice(4)),
                    // TODO Top insights
                    // TODO Discover more
                ];
                break;
            case 'md':
            case 'sm':
            case 'xs':
            case 'xxs':
                items = [
                    pinned,
                    ...getTypedItems(articles.slice(1, 4)),
                    ...getTypedItems(featuredFromOthers.slice(0, 1), 'featuredFromOthers'),
                    ...getTypedItems(articles.slice(4, 7)),
                    ...getTypedItems(featuredFromOthers.slice(1, 2), 'featuredFromOthers'),
                    // TODO Top insights
                    ...getTypedItems(articles.slice(7)),
                    // TODO Discover more
                ];
                break;
            case 'xxl':
            case 'xl':
            default:
                items = [pinned, ...getTypedItems(articles.slice(1))];
        }

        // Filter out undefined items
        items = items.filter((x) => x);
        return items;
    };

    useEffect(() => {
        setListItems(getItems());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [breakpoint]);

    useEffect(() => {
        setListItems(listItems.concat(getTypedItems(additionalArticles)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [additionalArticles]);

    return listItems;
};

export default useListItems;
